export default function searchProducts(originalProductList, searchTerm) {
  const filteredData = originalProductList.filter(
    (item) =>
      item.product_name?.toLowerCase().includes(searchTerm) ||
      item.vendor?.toLowerCase().includes(searchTerm)
  );
  return filteredData;
}
